import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Typography, Badge } from "antd";

import * as ordersActions from "../../redux/actions/orders";
import * as filtersActions from "../../redux/actions/filters";
import { getProfileFilters } from "../../../../SystemSettings/redux/actions/filters/filters";

import PlacemarkMap from "../../../common/PlacemarkMap/PlacemarkMap";
import OrdersTable from "../../components/Orders/Table/Table";
import ConfigTableColumns from "../../components/Orders/ConfigTableColumns/ConfigTableColumns";
import TopPanel from "../../components/Orders/TopPanel/TopPanel";
// import FiltersInfoPanel from '../../components/Orders/FiltersInfoPanel/FiltersInfoPanel';
import Filters from "../../components/Orders/Filters/Filters";

import Footer from "../../../../../common/hoc/withFooter";

import { getNumberWithoutSpaces } from "../../../../../common/utils/format";
import { getSortObjectBySorter } from "../../../Executorship";
import "./Orders.css";

const { Text } = Typography;
const { watchOrder, unwatchOrder, getAllOrders } = ordersActions;
const {
  updateFilterFieldsOrders,
  changeTypeListOrders,
  searchOrders,
  resetFiltersOrders
} = filtersActions;

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMap: false,
      isDrawerVisible: false,
      drawerCols: {
        info: true,
        view: true,
        state: true,
        passengers: true,
        price: true,
        routeLength: true,
        dateApplication: true,
        placeDelivery: true,
        settlementForm: false,
        driver: false,
        finalDestination: false,
        dateCreation: false,
        statusSendingACBDPL: false,
        sendingTrafficPolice: false
      },
      tableColumnsLen: 0,
      showFilterAll: false,
      pagination: {
        pages: 3
      },
      visibleSuccessSaveFilter: false,
      visibleAcceptSaveFilter: false,
      orders: [],
      markers: []
    };
    this.state.tableColumnsLen = this.getTableColumnsLen();
  }

  componentDidMount() {
    this.updateData();
    if (!this.props.settingsFilters) {
      this.props.getProfileFilters();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.orders !== this.props.orders ||
      prevProps.filters !== this.props.filters
    ) {
      this.updateData();
    }
  }

  updateData = () => {
    if (this.props.orders) {
      const orders =
        this.props.filters.typeList && this.props.filters.typeList !== "all"
          ? this.props.orders.filter(
              item =>
                item.state &&
                item.state.statusKeyGroup === this.props.filters.typeList
            )
          : this.props.orders;

      let markers = [];
      orders.forEach(item => {
        if (item.map) {
          markers.push(item.map);
        }
      });
      this.setState({
        orders,
        markers
      });
    }
  };

  toggleAllFilter = () => {
    this.setState(() => ({
      showFilterAll: !this.state.showFilterAll
    }));
  };

  resetFilters = () => {
    this.props.resetFiltersOrders();
    this.props.getAllOrders();
  };

  toggleSaveCurrentFilter = () => {
    this.setState(() => ({
      visibleSuccessSaveFilter: !this.state.visibleSuccessSaveFilter
    }));
  };

  toggleAcceptCurrentFilter = () => {
    this.setState(() => ({
      visibleAcceptSaveFilter: !this.state.visibleAcceptSaveFilter
    }));
  };

  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e)
      }
    }));
  };

  toggleVisibleMap = () => {
    const visibleMap = this.state.visibleMap;

    this.setState(() => ({
      visibleMap: !visibleMap
    }));
  };

  onChangeTable = (pagination, filters, sorter) => {
    const sort = getSortObjectBySorter(sorter);

    this.props.getAllOrders({ pagination, sort });
  };

  onChangeTypeList = e => {
    let statusOrder = e.target.value;
    this.props.changeTypeListOrders(statusOrder);
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.props.searchOrders(value);
  };

  onColsChange = e => {
    const { drawerCols } = this.state;
    const newDrawerCols = {
      ...drawerCols,
      [e.target.name]: e.target.checked
    };
    const tableColumnsLen = this.getTableColumnsLen(newDrawerCols);
    this.setState({
      drawerCols: newDrawerCols,
      tableColumnsLen
    });
  };

  getTableColumnsLen = (drawerCols = null) => {
    return Object.values(
      drawerCols ? drawerCols : this.state.drawerCols
    ).reduce((count, val) => (val === true ? ++count : count), 0);
  };

  showDrawer = () => {
    this.setState({
      isDrawerVisible: true
    });
  };

  closeDrawer = () => {
    this.setState({
      isDrawerVisible: false
    });
  };

  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];

    let cols = [
      {
        title: "Номер заказа",
        title_full: "Номер заказа (Наименование)",
        dataIndex: "info",
        key: "info",
        render: info => (
          <span>
            <Text>
              {info.orderNumber && getNumberWithoutSpaces(info.orderNumber)}
            </Text>
            <br />
            {info.change && info.change !== info.create ? (
              <Text>Изменен: {moment(info.change).format("DD.MM.YYYY")}</Text>
            ) : info.create ? (
              <Text type="secondary">
                Создан: {moment(info.create).format("DD.MM.YYYY")}
              </Text>
            ) : null}
          </span>
        ),
        sorter: true
      },
      {
        title: "Вид",
        title_full: "Вид транспортной услуги",
        dataIndex: "view",
        key: "view",
        render: view => (
          <span>
            <Text style={{ textTransform: "uppercase" }}>{view.abbr}</Text>
            <br />
            <Text style={{ color: view.color }}>{view.description}</Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Статус",
        title_full: "Статус заказа",
        dataIndex: "state",
        key: "state",
        render: state => (
          <span>
            <Text>
              {state.status === "Выполняется" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#00a8ff",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status === "Бронь" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#9b9b9b",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status === "Готов к выполнению" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#97dc76",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status === "Назначение" && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: "#d9d9d9",
                    marginRight: 8,
                    marginTop: 3
                  }}
                />
              )}
              {state.status}
            </Text>
            <br />
            <Text type="secondary" style={{ color: state.color }}>
              {state.description}
            </Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Пасс.",
        title_full: "Количество пассажиров",
        dataIndex: "passengers",
        key: "passengers",
        render: passengers => (
          <span>{passengers === "0" ? "—" : passengers}</span>
        ),
        sorter: true
      },
      {
        title: "Цена",
        key: "price",
        render: row => {
          return row.totalPrice ? (
            <Text>{getNumberWithoutSpaces(row.totalPrice)} ₽</Text>
          ) : null;
        },
        sorter: (a, b) => {
          return a.price && a.price - b.price.total;
        }
      },
      {
        title: "Дата подачи",
        title_full: "",
        dataIndex: "dateApplication",
        key: "dateApplication",
        render: dateApplication =>
          dateApplication ? (
            <span>
              {moment(dateApplication).format("DD.MM.YYYY HH:mm")}
              <br />
              <Text type="secondary">{moment(dateApplication).fromNow()}</Text>
            </span>
          ) : null,
        sorter: true
      },
      {
        title: "Место подачи",
        title_full: "",
        dataIndex: "placeDelivery",
        key: "placeDelivery",
        render: placeDelivery => (
          <span style={{ whiteSpace: "normal" }}>
            <Text>{placeDelivery.address}</Text>
            <br />
            <Text type="secondary">{placeDelivery.city}</Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Форма расчетов",
        title_full: "",
        dataIndex: "settlementForm",
        key: "settlementForm",
        render: settlementForm => (
          <span>
            <Text>{settlementForm.description}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return (
            a.settlementForm.id && a.settlementForm.id - b.settlementForm.id
          );
        }
      },
      {
        title: "Водитель",
        title_full: "",
        dataIndex: "driver",
        key: "driver",
        render: driver =>
          driver && driver.length > 0
            ? driver.map(item => <div key={item.id}>{item.userName}</div>)
            : ""
      },
      {
        title: "Конечный пункт",
        title_full: "",
        dataIndex: "finalDestination",
        key: "finalDestination",
        render: finalDestination => (
          <span>
            <Text>{finalDestination.address}</Text>
            <br />
            <Text type="secondary">{finalDestination.city}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.finalDestination.city.localeCompare(b.finalDestination.city);
        }
      },
      {
        title: "Дата создания",
        title_full: "",
        dataIndex: "info",
        key: "dateCreation",
        render: info =>
          info.create ? (
            <span>
              {moment(info.create).format("DD.MM.YYYY HH:mm")}
              <br />
              <Text type="secondary">{moment(info.create).fromNow()}</Text>
            </span>
          ) : null,
        sorter: (a, b) => {
          return a.info.create && a.info.create.localeCompare(b.info.create);
        }
      },
      {
        title: "Статус отправки в АЦБПДП",
        title_full: "",
        dataIndex: "statusSendingACBDP",
        key: "statusSendingACBDP"
      },
      {
        title: "Отправка в ГИБДД",
        title_full: "",
        dataIndex: "sendingTrafficPolice",
        key: "sendingTrafficPolice"
      }
    ];

    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    return filteredCols;
  };

  handleClickRow = row => {
    return {
      onClick: () => {
        !row.watched && this.props.watchOrder([row.id]);
        this.props.history.push(`/executorship/order/${row.id}`);
      }
    };
  };

  onChangeRowSelection = row => {};

  handleFiltersChange = values => {
    const val = Object.keys(values).reduce((acc, key) => {
      if (values[key]) {
        if (Array.isArray(values[key]) && values[key].length === 0) {
          return acc;
        }
        acc[key] = values[key];
      }
      return acc;
    }, {});
    this.props.updateFilterFieldsOrders(val);
  };

  render() {
    const {
      isDrawerVisible,
      drawerCols,
      pagination,
      showFilterAll,
      orders,
      markers
    } = this.state;

    return (
      <div className="orders">
        <ConfigTableColumns
          columns={drawerCols}
          visible={isDrawerVisible}
          close={this.closeDrawer}
          changed={this.onColsChange}
        />
        <div className="orders__content">
          <TopPanel
            typesList={this.props.orderTypes}
            stat={this.props.ordersStat}
            totalOrders={this.props.orders ? this.props.orders.length : 0}
            onChangeTypeList={this.onChangeTypeList}
            onChangeSearch={this.onChangeSearch}
          />
          <div className="orders__filters">
            {/* <FiltersInfoPanel
              visibleSuccessSaveFilter={this.state.visibleSuccessSaveFilter}
              visibleAcceptSaveFilter={this.state.visibleAcceptSaveFilter}
              visibleMap={this.state.visibleMap}
              toggleVisibleMap={this.toggleVisibleMap}
              resetFilters={this.resetFilters}
              toggleAcceptCurrentFilter={this.toggleAcceptCurrentFilter}
              toggleSaveCurrentFilter={this.toggleSaveCurrentFilter}
              profileFiltersCount={
                this.props.settingsFilters &&
                this.props.settingsFilters.ord &&
                this.props.settingsFilters.ord.keys ? this.props.settingsFilters.ord.keys.length : 0
              }
            />*/}
            <Filters
              showFilterAll={showFilterAll}
              showDrawer={this.showDrawer}
              toggleAllFilter={this.toggleAllFilter}
              handleFiltersChange={this.handleFiltersChange}
              visibleMap={this.state.visibleMap}
              toggleVisibleMap={this.toggleVisibleMap}
              settingsFilters={
                this.props.settingsFilters &&
                this.props.settingsFilters.ord &&
                this.props.settingsFilters.ord.keys
              }
              resetFilters={this.resetFilters}
            />
          </div>
          <div className="orders__map">
            {this.state.visibleMap && <PlacemarkMap markers={markers} />}
          </div>
          <OrdersTable
            renderColumns={this.renderColumns}
            tableColumnsLen={this.state.tableColumnsLen}
            orders={orders}
            pages={pagination.pages}
            ordersLoading={this.props.ordersLoading}
            changePaginationSize={this.changePaginationSize}
            onChangeTable={this.onChangeTable}
            handleClickRow={this.handleClickRow}
            onChangeRowSelection={this.onChangeRowSelection}
            watchedRecords={true}
          />
        </div>
        <Footer>
          {/*<OrdersFooter />*/}
        </Footer>
      </div>
    );
  }
}

export default connect(
  state => {
    const { orders, filters } = state.Executorship.Orders;
    const { profileFilters } = state.SystemSettings.filters;
    return {
      ordersLoading: orders.ordersLoading,
      orders: filters.count > 0 ? orders.filterOrders : orders.allOrders,
      ordersStat:
        filters.count > 0 ? orders.filterOrdersStat : orders.allOrdersStat,
      orderTypes: orders.orderTypes,
      filters,
      settingsFilters: profileFilters
    };
  },
  {
    watchOrder,
    unwatchOrder,
    getAllOrders,
    // Filters
    updateFilterFieldsOrders,
    searchOrders,
    changeTypeListOrders,
    resetFiltersOrders,
    // settings filters
    getProfileFilters
  }
)(Orders);
